import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

export function PlainBeforeAfter({
	before,
	after,
	beforeLabel = "Before",
	afterLabel = "After",
	beforeTestId,
	afterTestId,
	className,
}: {
	before: ReactNode;
	after: ReactNode;
	beforeLabel?: string;
	afterLabel?: string;
	beforeTestId?: string;
	afterTestId?: string;
	className?: string;
}) {
	return (
		<dl
			className={cn(
				"overflow-hidden rounded-md border border-border bg-card text-sm",
				className,
			)}
		>
			<div className="px-3 py-2.5">
				<dt className="text-[11px] font-medium uppercase tracking-wide text-muted-foreground">
					{beforeLabel}
				</dt>
				<dd
					data-testid={beforeTestId}
					className="mt-1 max-h-56 overflow-auto whitespace-pre-wrap break-words leading-relaxed text-muted-foreground"
				>
					{before}
				</dd>
			</div>
			<div className="border-t border-border bg-muted/40 px-3 py-2.5">
				<dt className="text-[11px] font-medium uppercase tracking-wide text-foreground">
					{afterLabel}
				</dt>
				<dd
					data-testid={afterTestId}
					className="mt-1 max-h-56 overflow-auto whitespace-pre-wrap break-words font-medium leading-relaxed text-foreground"
				>
					{after}
				</dd>
			</div>
		</dl>
	);
}
